import React, { useEffect, useState, useRef, useMemo } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";
import moment from "moment";
import $ from "jquery";

import "datatables.net-bs4/js/dataTables.bootstrap4.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";

const PAGE_BODY_CLASS = "hr-gr-user-book-page";

const formatEventTitle = (event) => {
  if (!event) return "";
  let time = "";
  if (event.evt_od) {
    time = moment(Number(new Date(event.evt_od))).local().format("hh:mm A");
  }
  const parts = [time, event.evt_evt, event.matchSummaryText4].filter(Boolean);
  return parts.join(" ");
};

const HrGrUserBook = () => {
  const { cat_mid } = useParams();

  const [event, setEvent] = useState(null);
  const [runners, setRunners] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("allusers");
  const [gridKey, setGridKey] = useState(Date.now());

  const tableRef = useRef(null);

  useEffect(() => {
    document.documentElement.classList.add(PAGE_BODY_CLASS);
    document.body.classList.add(PAGE_BODY_CLASS);
    return () => {
      document.documentElement.classList.remove(PAGE_BODY_CLASS);
      document.body.classList.remove(PAGE_BODY_CLASS);
    };
  }, []);

  const fetchData = async (reqtype) => {
    setLoading(true);
    try {
      const res = await axiosInstance.post(`/markets/hr-gr-user-book/${cat_mid}`, {
        reqtype
      });
      setEvent(res.data.event || null);
      setRunners(res.data.runners || []);
      setRows(res.data.returnResult || []);
      setGridKey(Date.now());
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData(activeTab);
  }, [cat_mid, activeTab]);

  const formatValue = (obj) => {
    if (!obj) return "0";
    return `<span style="color:${obj.color}">${Number(
      obj.value
    ).toLocaleString()}</span>`;
  };

  const cols = useMemo(() => {
    const c = [
      {
        title: "Username",
        data: "username",
        className: "all",
        render: (d) =>
          `<span class="site_family" style="font-size:14px">${d}</span>`,
        orderable: true,
        responsivePriority: 1
      }
    ];

    runners.forEach((runner) => {
      const key = `rnr_${runner.section_id}`;
      const sortKey = `${key}_sort`;
      c.push({
        title: runner.runner_name,
        data: key,
        className: "all",
        orderable: true,
        responsivePriority: 1,
        render: (data, type, row) => {
          if (type === "sort" || type === "type" || type === "filter") {
            return row[sortKey] ?? 0;
          }
          return `<span class="site_family" style="font-size:14px">${data}</span>`;
        }
      });
    });

    return c;
  }, [runners]);

  useEffect(() => {
    if (loading || !cols.length) return;

    const $table = $(tableRef.current);
    if (!$table.length) return;

    if ($.fn.dataTable.isDataTable($table)) {
      $table.DataTable().destroy(true);
      $table.empty();
    }

    const safeData = rows.map((r) => {
      const row = { username: r.username };
      runners.forEach((runner) => {
        const book =
          r.books?.[runner.section_id] || r.books?.[String(runner.section_id)];
        const key = `rnr_${runner.section_id}`;
        row[key] = formatValue(book);
        row[`${key}_sort`] = Number(book?.value ?? 0);
      });
      return row;
    });

    $table.DataTable({
      data: safeData,
      columns: cols,
      responsive: false,
      paging: true,
      pageLength: 100,
      lengthChange: true,
      lengthMenu: [100, 250, 500, 1000],
      searching: true,
      info: true,
      ordering: true,
      order: [[0, "asc"]],
      autoWidth: false,
      orderClasses: false,
      pagingType: "simple_numbers",
      scrollX: true,
      dom:
        '<"row mb-2 hr-gr-user-book-dt-toolbar justify-content-center align-items-center"<"col-auto"l><"col-auto"f>>' +
        "rt" +
        '<"row mt-2 hr-gr-user-book-dt-footer justify-content-between align-items-center"<"col-auto"i><"col-auto"p>>',
      language: {
        paginate: {
          previous: "Previous",
          next: "Next"
        },
        lengthMenu: "Show _MENU_ entries",
        search: "Search:",
        searchPlaceholder: ""
      },
      rowCallback: function (row, data, index) {
        const bgColor = index % 2 === 0 ? "#f9f9f9" : "#ffffff";
        $(row).css("background-color", bgColor);
        $("td", row).css("background-color", bgColor);
      }
    });

    return () => {
      if ($.fn.dataTable.isDataTable($table)) {
        $table.DataTable().destroy(true);
      }
    };
  }, [rows, cols, loading, gridKey, runners]);

  return (
    <div className="hr-gr-user-book">
      <main className="main">
        <div className="container-fluid hr-gr-user-book-container">
          {loading && (
            <div
              style={{
                textAlign: "center",
                position: "absolute",
                left: 0,
                right: 0,
                zIndex: 999
              }}
            >
              <img src="/assets/images/loadinggif.gif" alt="" />
            </div>
          )}

          <div className="animated fadeIn" style={{ margin: "8px" }}>
            <div className="site_family">
              <h4>{formatEventTitle(event)}</h4>
            </div>

            <div style={{ paddingLeft: "15px", marginBottom: "10px" }}>
              <button
                className="btn btn-primary site_family hr-gr-user-book-refresh-btn"
                onClick={() => fetchData(activeTab)}
              >
                Refresh
              </button>
            </div>

            <div className="card-body">
              <ul className="nav nav-tabs">
                <li className="nav-item">
                  <a
                    href="#"
                    style={{
                      width: "63px",
                      padding: "5px",
                      textAlign: "center"
                    }}
                    className={`site_family nav-link ${
                      activeTab === "allusers" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveTab("allusers");
                    }}
                  >
                    ALL
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    style={{
                      width: "103px",
                      padding: "5px",
                      textAlign: "center"
                    }}
                    href="#"
                    className={`site_family nav-link ${
                      activeTab === "myusers" ? "active" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveTab("myusers");
                    }}
                  >
                    My Users
                  </a>
                </li>
              </ul>
              <hr className="hr-gr-user-book-tabs-divider" />

              <div className="tab-content p-2">
                <div className="tab-pane fade show active">
                  <div className="hr-gr-user-book-table-wrap" key={gridKey}>
                    <table
                      ref={tableRef}
                      className="table table-striped table-bordered dataTable no-footer display mt-2"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          {cols.map((c) => (
                            <th
                              key={c.data}
                              className="site_family"
                              style={{ fontSize: "14px" }}
                            >
                              {c.title}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody />
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <style>{`
  html.${PAGE_BODY_CLASS},
  body.${PAGE_BODY_CLASS},
  body.${PAGE_BODY_CLASS} #root {
    background-color: #fff !important;
    background-image: none !important;
  }

  .hr-gr-user-book,
  .hr-gr-user-book .main,
  .hr-gr-user-book .container-fluid,
  .hr-gr-user-book .animated,
  .hr-gr-user-book .card-body,
  .hr-gr-user-book .tab-content,
  .hr-gr-user-book .tab-pane {
    background-color: #fff !important;
  }

  .hr-gr-user-book {
    min-height: 100vh;
    width: 100%;
    box-sizing: border-box;
  }

  .hr-gr-user-book .hr-gr-user-book-container {
    padding: 20px !important;
    box-sizing: border-box;
  }

  .hr-gr-user-book .hr-gr-user-book-event-title {
    font-weight: bold;
    margin: 5px;
    padding: 6px 15px;
    background: #f8d7e4;
    font-size: calc(1em + 4px);
  }

  .hr-gr-user-book .tab-content,
  .hr-gr-user-book .tab-pane {
    border: none !important;
    overflow: visible !important;
  }

  .hr-gr-user-book .hr-gr-user-book-table-wrap,
  .hr-gr-user-book .dt-container {
    border: none !important;
    display: block;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    overflow-x: auto !important;
    padding-right: 1px;
  }

  .hr-gr-user-book .table.table-bordered {
    border: 1px solid #ddd !important;
    border-collapse: collapse !important;
    width: 100% !important;
    max-width: 100%;
    box-sizing: border-box;
  }

  .hr-gr-user-book .table.table-bordered th:last-child,
  .hr-gr-user-book .table.table-bordered td:last-child {
    border-right: 1px solid #ddd !important;
  }

  .hr-gr-user-book table.dataTable > thead > tr > th,
  .hr-gr-user-book table.dataTable > tbody > tr > td {
    display: table-cell !important;
  }

  .hr-gr-user-book .table.table-bordered th,
  .hr-gr-user-book .table.table-bordered td {
    border-width: 1px !important;
    border-style: solid !important;
    border-color: #ddd !important;
    text-align: left !important;
    white-space: nowrap !important;
    padding: 6px 8px !important;
    font-size: 17px;
    vertical-align: middle;
  }

  .hr-gr-user-book thead th {
    font-weight: 700 !important;
    vertical-align: middle !important;
    background-image: none !important;
  }

  .hr-gr-user-book .table.table-bordered thead tr th {
    border-bottom: 0px solid #ffffff;
  }

  .hr-gr-user-book thead th::before,
  .hr-gr-user-book thead th::after {
    display: none !important;
    content: none !important;
  }

  .hr-gr-user-book thead th .dt-column-header {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    width: 100%;
    gap: 8px;
    text-align: left !important;
  }

  .hr-gr-user-book thead th .dt-column-order {
    flex: 0 0 29px;
    width: 29px;
    min-width: 29px;
    height: 18px;
    margin-left: auto;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 29px 18px;
    cursor: pointer;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='16' viewBox='0 0 18 16'%3E%3Cpath fill='none' stroke='%23888888' stroke-width='2' stroke-linecap='round' d='M5 2v8'/%3E%3Cpath fill='%23888888' d='M5 13.5 2 10h6z'/%3E%3Cpath fill='none' stroke='%23888888' stroke-width='2' stroke-linecap='round' d='M10 14V6'/%3E%3Cpath fill='%23888888' d='M10 2.5 7 6h6z'/%3E%3C/svg%3E");
  }

  .hr-gr-user-book thead th .dt-column-order::before,
  .hr-gr-user-book thead th .dt-column-order::after {
    display: none !important;
    content: none !important;
  }

  .hr-gr-user-book thead th.dt-ordering-desc .dt-column-order {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='16' viewBox='0 0 20 16'%3E%3Cpath fill='none' stroke='%23888888' stroke-width='2' stroke-linecap='round' d='M5 2v8'/%3E%3Cpath fill='%23888888' d='M5 13.5 2 10h6z'/%3E%3Crect x='9' y='2.5' width='8' height='2' fill='%23aaaaaa'/%3E%3Crect x='9' y='6' width='6' height='2' fill='%23aaaaaa'/%3E%3Crect x='9' y='9.5' width='4' height='2' fill='%23aaaaaa'/%3E%3C/svg%3E");
  }

  .hr-gr-user-book thead th.dt-ordering-asc .dt-column-order {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='16' viewBox='0 0 20 16'%3E%3Cpath fill='none' stroke='%23888888' stroke-width='2' stroke-linecap='round' d='M5 14V6'/%3E%3Cpath fill='%23888888' d='M5 2.5 2 6h6z'/%3E%3Crect x='9' y='11.5' width='8' height='2' fill='%23aaaaaa'/%3E%3Crect x='9' y='8' width='6' height='2' fill='%23aaaaaa'/%3E%3Crect x='9' y='4.5' width='4' height='2' fill='%23aaaaaa'/%3E%3C/svg%3E");
  }

  .hr-gr-user-book .hr-gr-user-book-tabs-divider {
    margin: 0 0 8px;
    border: 0;
    border-top: 1px solid #ddd;
  }

  .hr-gr-user-book .hr-gr-user-book-refresh-btn {
    background-color: #337ab7 !important;
    background-image: none !important;
    border: 1px solid #2e6da4 !important;
  }

  .hr-gr-user-book .hr-gr-user-book-dt-toolbar {
    display: flex !important;
    flex-wrap: wrap;
    justify-content: space-between !important;
    align-items: center !important;
    width: 100%;
    margin-right: 0 !important;
  }

  .hr-gr-user-book .hr-gr-user-book-dt-toolbar .dt-length,
  .hr-gr-user-book .hr-gr-user-book-dt-toolbar .dataTables_length,
  .hr-gr-user-book .hr-gr-user-book-dt-toolbar .dt-search,
  .hr-gr-user-book .hr-gr-user-book-dt-toolbar .dataTables_filter {
    display: inline-flex !important;
    align-items: center !important;
    gap: 8px;
    float: none !important;
    margin: 0 !important;
  }

  .hr-gr-user-book .hr-gr-user-book-dt-toolbar label {
    margin-bottom: 0 !important;
    white-space: nowrap;
  }

  .hr-gr-user-book .hr-gr-user-book-dt-toolbar select.form-control,
  .hr-gr-user-book .hr-gr-user-book-dt-toolbar .custom-select {
    width: auto !important;
    min-width: 4.5rem;
    display: inline-block;
    border: 1px solid #ced4da !important;
    height: calc(1.5em + 0.5rem + 2px);
    padding: 0.25rem 1.75rem 0.25rem 0.5rem;
  }

  .hr-gr-user-book .hr-gr-user-book-dt-toolbar .dt-search input[type="search"],
  .hr-gr-user-book .hr-gr-user-book-dt-toolbar .dataTables_filter input[type="search"] {
    border: 1px solid #ced4da !important;
    width: 200px !important;
    margin: 0 !important;
    display: inline-block !important;
  }

  .hr-gr-user-book .hr-gr-user-book-dt-footer {
    display: flex !important;
    flex-wrap: wrap;
    justify-content: space-between !important;
    align-items: center !important;
    width: 100%;
    margin-top: 0.75rem !important;
  }

  .hr-gr-user-book .hr-gr-user-book-dt-footer .dt-info {
    float: none !important;
    color: #333;
    font-size: 16px;
    white-space: nowrap;
  }

  .hr-gr-user-book .hr-gr-user-book-dt-footer .pagination {
    display: flex !important;
    flex-wrap: wrap;
    margin: 0 !important;
    padding: 0;
  }

  .hr-gr-user-book .hr-gr-user-book-dt-footer .page-link {
    position: relative;
    display: block;
    padding: 0.375rem 0.75rem;
    color: #777;
    background-color: #fff;
    border: 1px solid #ddd !important;
    line-height: 1.25;
    margin-left: -1px;
  }

  .hr-gr-user-book .hr-gr-user-book-dt-footer .page-item.active .page-link {
    z-index: 1;
    color: #fff !important;
    background-color: #337ab7 !important;
    border-color: #337ab7 !important;
  }

  .hr-gr-user-book .hr-gr-user-book-dt-footer .page-item.disabled .page-link {
    color: #6c757d !important;
    background-color: #fff !important;
    border-color: #ddd !important;
    pointer-events: none;
  }

  .hr-gr-user-book .nav-tabs {
    border-bottom: none !important;
  }

  .hr-gr-user-book .nav-tabs .site_family.nav-link {
    color: #337ab7 !important;
  }

  .hr-gr-user-book .nav-tabs .site_family.nav-link.active {
    border: none !important;
    border-bottom: 2px solid #337ab7 !important;
    color: #337ab7 !important;
  }

  .hr-gr-user-book .table tbody tr:nth-child(odd),
  .hr-gr-user-book .table tbody tr:nth-child(odd) > td {
    background-color: #f9f9f9 !important;
  }

  .hr-gr-user-book .table tbody tr:nth-child(even),
  .hr-gr-user-book .table tbody tr:nth-child(even) > td {
    background-color: #ffffff !important;
  }

  .hr-gr-user-book table.dataTable.order-column tbody tr > .sorting_1,
  .hr-gr-user-book table.dataTable.display tbody tr > .sorting_1 {
    background-color: inherit !important;
  }

  .hr-gr-user-book .table.table-bordered thead tr th {
     border-bottom: 0px solid #ddd !important;
}
<style>

`}</style>
      </main>
    </div>
  );
};

export default HrGrUserBook;
